webpackJsonp([244213359488166],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fragments = undefined;
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var participants = _ref.participants;
	  return _react2.default.createElement(
	    'div',
	    null,
	    participants.map(function (participant) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'list-item', key: participant.permalink },
	        _react2.default.createElement(
	          'strong',
	          { className: 'emphasized' },
	          participant.name
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: participant.fields.textHtml } }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: participant.website },
	          participant.website
	        )
	      );
	    })
	  );
	};
	
	var fragments = exports.fragments = '** extracted graphql fragment **';

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _participantListing = __webpack_require__(205);
	
	var _participantListing2 = _interopRequireDefault(_participantListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'breadcrumb' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Home'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u203A '
	      ),
	      'TeilnehmerInnen'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      'TeilnehmerInnen'
	    ),
	    _react2.default.createElement(_participantListing2.default, { participants: data.allParticipantsYaml.edges.map(function (edge) {
	        return edge.node;
	      }) })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-participants-js-6ce17bb4b02d60c7ae2d.js